import i18n from "i18next";
import { initReactI18next } from "react-i18next";

const language = window.location.pathname.substring(
  window.location.pathname.length - 3
);
const languageLoader = () =>
  (language === "/ka" && "ka") ||
  (language === "/en" && "en") ||
  localStorage.getItem("culture") ||
  "ka";

const resources = {
  en: {
    translation: {
      username: 'Name',
      surname: 'Last Name',
      email: 'E-mail',
      username: 'Name',
      mobileNumber:'Phone Number',
      message:'Message',
      send:'Send',
      modalText: 'Please note that when submitting information anonymously, the study activities may be limited, since feedback from anonymous whistleblowers would not be available.',
      result:'Your message has been sent',
      error1:'Please enter a valid email address',
      error2:'Please enter a message',
      languageGe: "GE",
      languageEn: "ENG",
    },
  },
  ka: {
    translation: {
      username: 'სახელი',
      surname: 'გვარი',
      email: 'ელ.ფოსტა',
      mobileNumber:'მობილურის ნომერი',
      message:'შეტყობინება',
      send:'გაგზავნა',
      modalText: 'გთხოვთ, გაითვალისწინოთ, რომ ინფორმაციის ანონიმურად მოწოდებით, შესაძლებელია შეზღუდული იყოს კვლევისთვის განხორციელებული ქმედება, რადგან ანონიმურ მამხილებელთან შეუძლებელი იქნება უკუკავშირი',
      result:'თქვენი შეტყობინება გაიგზავნა',
      error1:'გთხოვთ შეიყვანოთ სწორი ელ.ფოსტა',
      error2:'გთხოვთ, შეიყვანოთ შეტყობინება',
      languageGe: "GE",
      languageEn: "ENG",

    },
  },
};

const syncDocumentLanguage = (language) => {
  document.documentElement.lang = language;
};

syncDocumentLanguage(languageLoader());
i18n.on('languageChanged', syncDocumentLanguage);

i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    whitelist: ["ka", "en"],
    resources,
    lng: languageLoader(), // language to use, more information here: https://www.i18next.com/overview/configuration-options#languages-namespaces-resources
    // you can use the i18n.changeLanguage function to change the language manually: https://www.i18next.com/overview/api#changelanguage
    // if you're using a language detector, do not define the lng option

    interpolation: {
      escapeValue: false, // react already safes from xss
    },
    keySeparator: false, // we do not use keys in form messages.welcome3
  });

export default i18n;
